export default "__VITE_ASSET__DLFqoJ6O__"